import ReadingsChart from '../../../components/readings-chart'
import merge from 'lodash.merge';
import roundTo from 'round-to'

const lightChart = (chartEl, options = {}) => {

  options = merge({
    label: 'Light',
    source: 'light',
    borderColor: '#db7903',
    backgroundColor: '#ffbd2d',
    tickFormat: (value, index, values) => {
      return roundTo(value, 0);
    },
    tooltipFormat: context => {
      return context.parsed.y;
    },
    valueConversion: value => {
      return Math.round(value);
    },
  }, options);

  const chart = new ReadingsChart(chartEl, options);

};

export default lightChart;
